export default {
    settingSuratIsActive: state => {
        return state.settingSurat.isActive;
    }
}